import { useEffect, useState } from 'react'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'
import React from 'react'
import Delayed from '../Delayed'

const Home = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  const firstName = [
    'H',
    'E',
    'S',
    'H',
    'A',
    'M',
    ' ',
    ' ',
    'N',
    'A',
    'S',
    'S',
    'E',
    'R',
  ]
  const lastName = []

  // @ts-ignore
  useEffect(() => {
    return setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 1000)
  }, [])

  return (
    <>
      <div className="container home-page">
        <div className="text-zone">
          <h2>
            <span>Hello!</span>

            <span className={letterClass}>👋</span>
            <span className={letterClass}>I</span>
            <span className={letterClass}></span>
            <span className={letterClass}>a</span>
            <span className={letterClass}>m</span>
          </h2>
          <h1>
            <br />

            <AnimatedLetters
              letterClass={letterClass}
              strArray={firstName}
              idx={15}
            />
            <br />
            <AnimatedLetters
              letterClass={letterClass}
              strArray={lastName}
              idx={22}
            />
          </h1>
          <Delayed>
            {' '}
            <hr
              style={{
                color: '#323232',
                backgroundColor: '#323232',
                height: 0.08,
                borderColor: '#323232',
                opacity: 0.5,
                marginTop: '23px',
                transition: ' opacity 2s',
              }}
            />
          </Delayed>

          <h2 className="home-description">
            UX generalist with data-driven mindset, background in animation and
            software engineering
          </h2>
        </div>
      </div>
    </>
  )
}

export default Home
